import { ReactElement } from "react";
import type { ArticleDataObject } from "@app/types/Cue";
import { LatestStoriesRowProps } from "@app/types/Verticals";
import VerticalLatest from "@components/ArticleCard/VerticalLatest";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import SeeMore from "@components/SeeMore/SeeMore";
import VerticalBlockTitle from "@components/VerticalBlockTitle/VerticalBlockTitle";
import cx from "classnames";

import MostReadStories from "./MostReadStories";

export default function LatestStoriesRow({
  testId,
  seeMoreLink,
  verticalName,
  articles,
  mostReadStories,
}: LatestStoriesRowProps): ReactElement {
  return (
    <>
      {articles.length > 0 || mostReadStories.length > 0 ? (
        <Row rootClassName="mb-12" data-testid={testId}>
          <Column rootClassName={cx("w-full", "lg:w-8/12")}>
            <VerticalBlockTitle text="Latest" rootClassName="mb-5" />

            <>
              {articles?.map((article: ArticleDataObject, index: number) => {
                return (
                  <VerticalLatest
                    articleData={article}
                    rootClassName="mb-4 pb-4 border-b border-gray-250"
                    key={index}
                    verticalName={verticalName}
                  />
                );
              })}
            </>

            <SeeMore verticalName={verticalName} link={seeMoreLink} />
          </Column>

          <Column rootClassName={cx("w-full", "lg:w-4/12")}>
            <MostReadStories
              articles={mostReadStories}
              verticalName={verticalName}
            />
          </Column>
        </Row>
      ) : null}
    </>
  );
}
